import { getDedicatedReportGroupBy, isDedicatedReportRoute } from '@/views/reports/report-route-behavior';

export type RouteMetricsDefinitions = {
  base: Record<string, unknown>;
  conversions: Record<string, unknown>;
  postbacks: Record<string, unknown>;
  errors: Record<string, unknown>;
  'live-clicks': Record<string, unknown>;
  'live-visits': Record<string, unknown>;
};

export const resolveRouteMetricsDefinition = (
  routeName: string | symbol | null | undefined,
  definitions: RouteMetricsDefinitions,
) => {
  if (!isDedicatedReportRoute(routeName)) {
    return definitions.base;
  }

  switch (getDedicatedReportGroupBy(routeName as string)) {
    case 'conversions':
      return definitions.conversions;
    case 'postbacks':
      return definitions.postbacks;
    case 'errors':
      return definitions.errors;
    case 'live-clicks':
      return definitions['live-clicks'];
    case 'live-visits':
      return definitions['live-visits'];
    default:
      return definitions.base;
  }
};
